// First Created - 07 Oct 2026
// Author - Atul Pandey
// Purpose - Update an Org Trail Session Q&A Assignment


import React, {
    useEffect,
    useState,
} from "react"


import {
    useNavigate,
} from "react-router"


import useTitle from "@/hooks/useTitle"


import EtBtnFormBasic
    from "@/components/common/buttons/EtBtnFormBasic"


import PulseLoader
    from "react-spinners/PulseLoader"


import {
    useGetOrgTrailSessionQNAAssignmentsQuery,
    useUpdateOrgTrailSessionQNAAssignmentMutation,
} from "./orgTrailSessionQNAAssignmentsApiSlice"



const EtUpdateOrgTrailSessionQNAAssignment = ({
    id,
    setActiveAdminView,
}) => {

    useTitle(
        "Update Session Q&A Assignment"
    )


    const {
        assignment,
        isLoading,
        isFetching,
    } =
        useGetOrgTrailSessionQNAAssignmentsQuery(
            {},
            {
                selectFromResult: ({
                    data,
                    isLoading,
                    isFetching,
                }) => ({

                    assignment:
                        data
                            ?.entities[
                                id
                            ],

                    isLoading,

                    isFetching,

                }),
            }
        )


    if (
        isLoading ||
        isFetching ||
        !assignment
    ) {

        return (
            <PulseLoader
                color="#ea580c"
            />
        )
    }


    return (

        <EtUpdateOrgTrailSessionQNAAssignmentForm

            assignment={
                assignment
            }

            id={
                id
            }

            setActiveAdminView={
                setActiveAdminView
            }

        />
    )
}



const EtUpdateOrgTrailSessionQNAAssignmentForm = ({
    assignment,
    id,
    setActiveAdminView,
}) => {

    const navigate =
        useNavigate()


    const [
        updateOrgTrailSessionQNAAssignment,
        {
            isLoading,
            isSuccess,
            isError,
            error,
        },
    ] =
        useUpdateOrgTrailSessionQNAAssignmentMutation()


    const [
        active,
        setActive,
    ] =
        useState(
            assignment
                ?.active !==
                false
        )



    useEffect(
        () => {

            if (
                isSuccess
            ) {

                if (
                    setActiveAdminView
                ) {

                    setActiveAdminView(
                        "orgTrailSessionQNAAssignments"
                    )

                } else {

                    navigate(
                        "/orgTrailSessionQNAAssignments"
                    )
                }
            }

        },
        [
            isSuccess,
            navigate,
            setActiveAdminView,
        ]
    )



    const handleSubmit =
        async (
            e
        ) => {

            e.preventDefault()


            try {

                const response =
                    await updateOrgTrailSessionQNAAssignment({

                        id,

                        active,

                    })
                        .unwrap()


                alert(
                    response
                        ?.message ||
                    "Session Q&A assignment updated successfully"
                )

            } catch (
                submitError
            ) {

                console.error(
                    submitError
                )


                alert(
                    submitError
                        ?.data
                        ?.message ||
                    "Failed to update Session Q&A assignment"
                )
            }
        }



    const handleCancel = () => {

        if (
            setActiveAdminView
        ) {

            setActiveAdminView(
                "orgTrailSessionQNAAssignments"
            )

        } else {

            navigate(
                "/orgTrailSessionQNAAssignments"
            )
        }
    }



    return (

        <div
            className="bg-gray-200 p-1 mx-auto mt-5 rounded-lg shadow-md shadow-black"
        >

            {
                isLoading &&
                (
                    <PulseLoader
                        color="#ea580c"
                    />
                )
            }


            {
                isError &&
                (
                    <p
                        className="text-orange-700 font-semi-bold py-2"
                    >
                        {
                            error
                                ?.data
                                ?.message
                        }
                    </p>
                )
            }


            <div
                className="bg-white p-1 m-1 rounded"
            >

                <p
                    className="p-1 m-1 font-bold font-poppins text-xl"
                >
                    Update Session Q&A Assignment
                </p>


                <div
                    className="bg-gray-200 rounded m-1 p-1"
                >

                    <form
                        onSubmit={
                            handleSubmit
                        }

                        className="m-1 p-1 text-xs font-poppins"
                    >


                        {
                            [
                                {
                                    label:
                                        "Organization",

                                    value:
                                        assignment
                                            ?.orgId
                                            ?.organizationName,
                                },

                                {
                                    label:
                                        "Trail",

                                    value:
                                        assignment
                                            ?.trailId
                                            ?.trailName,
                                },

                                {
                                    label:
                                        "Cohort",

                                    value:
                                        assignment
                                            ?.cohortId
                                            ?.cohortName ||
                                        assignment
                                            ?.cohortId
                                            ?.cohortCode,
                                },

                                {
                                    label:
                                        "Session",

                                    value:
                                        assignment
                                            ?.sessionId
                                            ?.sessionName,
                                },

                                {
                                    label:
                                        "Session Q&A Set",

                                    value:
                                        assignment
                                            ?.sessionQNASetId
                                            ?.sessionQNAName,
                                },

                            ].map(
                                item => (

                                    <div
                                        key={
                                            item.label
                                        }

                                        className="bg-white rounded m-1 p-2"
                                    >

                                        <p
                                            className="font-bold text-xs m-1"
                                        >
                                            {
                                                item.label
                                            }
                                        </p>


                                        <input
                                            type="text"

                                            value={
                                                item.value ||
                                                "Not defined"
                                            }

                                            disabled

                                            className="w-full rounded p-2 m-1 bg-gray-100 text-gray-600 cursor-not-allowed"
                                        />

                                    </div>

                                )
                            )
                        }



                        <div
                            className="bg-white rounded m-1 p-2"
                        >

                            <div
                                className="flex justify-start items-center bg-gray-100 rounded m-1 p-2"
                            >

                                <input
                                    type="checkbox"

                                    checked={
                                        active
                                    }

                                    onChange={
                                        e =>
                                            setActive(
                                                e.target
                                                    .checked
                                            )
                                    }

                                    className="m-1"
                                />


                                <p
                                    className="text-xs font-bold text-gray-700 m-1"
                                >
                                    Active Assignment
                                </p>

                            </div>

                        </div>



                        <div
                            className="bg-white m-1 px-1 py-3 rounded"
                        >

                            <EtBtnFormBasic
                                name="Update"
                                type="create"
                                handleClick={
                                    handleSubmit
                                }
                            />


                            <EtBtnFormBasic
                                name="Cancel"
                                type="cancel"
                                handleClick={
                                    handleCancel
                                }
                            />

                        </div>

                    </form>

                </div>

            </div>

        </div>
    )
}


export default EtUpdateOrgTrailSessionQNAAssignment